/** @jsxImportSource @emotion/react */

import {AutoComplete as AntdAutoComplete} from 'antd'
import useInputable from './useInputable.mjs'
import useSelectable from './useSelectable.mjs'

const AutoComplete = ({
    allowClear,
    changeDelay,
    focus,
    hottestFirst,
    label,
    options,
    parse,
    searchText,
    selectOnFocus,
    test,
    title,
    transform,
    value,
    writeBack,
    onBlur,
    onChange,
    onInput,
    onSearch = onChange,
    onSelect = onChange,
    ...props
}) => {
    const {
        callbackRef,
        handleBlur,
        handleClick,
        handleCompositionEnd,
        handleCompositionStart,
        handleInput,
        inputValue,
        setInputValue,
    } = useInputable({
        allowClear,
        changeDelay,
        focus,
        parse,
        selectOnFocus,
        test,
        transform,
        value,
        onChange: onSearch,
        onBlur,
        onInput,
    })

    const handleSelect = (value) => {
        const {label} = antdOptions.find(
            (option) => option.value === value
        )

        setInputValue(label)
        onSelect(value)
    }

    const {
        antdOptions,
        filterOption,
        filterSort,
        handleChange,
    } = useSelectable({
        hottestFirst,
        label,
        options,
        searchText,
        setInputValue,
        title,
        writeBack,
        onChange: handleSelect,
    })

    const style = {
        display: 'block',
        width: '100%',
        color: 'inherit',
        overflow: 'hidden',
        ...props.style,

        'input': {
            textAlign: 'inherit',
        },
    }

    return (
        <div
            ref={callbackRef}
            style={{display: 'contents'}}
            onClick={handleClick}
        >
            <AntdAutoComplete
                allowClear={allowClear}
                filterOption={filterOption}
                filterSort={filterSort}
                options={antdOptions}
                showSearch
                size="small"
                value={inputValue}
                onBlur={handleBlur}
                onChange={onChange}
                onCompositionEnd={handleCompositionEnd}
                onCompositionStart={handleCompositionStart}
                onInput={handleInput}
                onSelect={handleChange}
                {...props}
                style={style}
            />
        </div>
    )
}

export default AutoComplete
